import { formatCentsToDollarsWithDollarSign } from "src/helpers";
import { formatDateTime } from "src/utils/date";
import { PaymentDetailsProps } from "src/interfaces/orders-props.interface";

const EMPTY_LABEL = "Not provided";

const PaymentDetails = ({ payment, compact }: PaymentDetailsProps) => {
  const labelCls = compact ? "text-[14px] text-[#6B7280] w-[140px] shrink-0" : "text-[#666666] text-sm w-[200px]";
  const valueCls = compact ? "text-[14px] font-semibold text-[#111827]" : "text-[#1A1A1A] text-sm font-medium";
  const emptyCls = compact ? "text-[14px] text-[#9CA3AF]" : "text-sm text-[#9CA3AF]";
  const rowCls = compact ? "flex items-center min-h-[24px]" : "flex mt-3 items-center";
  const titleCls = compact ? "text-[14px] font-semibold text-[#111827] mb-2" : "text-base text-[#1A1A1A] font-bold mt-6";

  const brand = payment?.paymentMethodBrand ? String(payment.paymentMethodBrand) : EMPTY_LABEL;
  const type = payment?.paymentMethodType ? String(payment.paymentMethodType) : EMPTY_LABEL;
  const last4 = payment?.last4Digits ? `**** **** **** ${payment.last4Digits}` : EMPTY_LABEL;
  const amount = payment?.paymentAmountCents != null ? formatCentsToDollarsWithDollarSign(payment.paymentAmountCents) : EMPTY_LABEL;
  const status = payment?.paymentStatus
    ? String(payment.paymentStatus).replace(/_/g, " ").toLowerCase().replace(/^\w/, (c: string) => c.toUpperCase())
    : EMPTY_LABEL;
  const date = payment?.paymentDate ? formatDateTime(payment.paymentDate) : EMPTY_LABEL;

  const isEmpty = (v: string) => v === EMPTY_LABEL;
  const valueSpan = (v: string, cls = valueCls) => <span className={isEmpty(v) ? emptyCls : cls}>{v}</span>;

  return (
    <>
      <h2 className={titleCls}>Payment Details</h2>
      <div className={rowCls}>
        <span className={labelCls}>Brand</span>
        {valueSpan(brand)}
      </div>
      <div className={rowCls}>
        <span className={labelCls}>Type</span>
        {valueSpan(type)}
      </div>
      <div className={rowCls}>
        <span className={labelCls}>Last 4 digits</span>
        {valueSpan(last4)}
      </div>
      <div className={rowCls}>
        <span className={labelCls}>Amount</span>
        {valueSpan(amount)}
      </div>
      <div className={rowCls}>
        <span className={labelCls}>Status</span>
        {valueSpan(status)}
      </div>
      <div className={rowCls}>
        <span className={labelCls}>Payment Date</span>
        {valueSpan(date)}
      </div>
    </>
  );
};

export default PaymentDetails;
